<template>
  <div>
    <game-intro v-if="setupGame.gameView == 1"></game-intro>
    <game-rules v-if="setupGame.gameView == 2"></game-rules>
    <game-lvl v-if="setupGame.gameView == 3" @gameIntro="gameIntro = $event" ></game-lvl>
    <mission-name v-if="setupGame.gameView != 1" v-bind:shopGame="shopGame" :mission-name="shopGame.missionName" :mission-title="shopGame.gameName"></mission-name>
    <game-order v-if="showGameAccess && !lastorder" :orderType="3"></game-order>
    <game-map v-if="showGameMap" :stepOrder="'game_tree'"></game-map>
    <div class="game-store" v-if="setupGame.gameView == 4"  ref="game">
      <div class="end-game-mask" v-if="gameOver">
        <div class="wrap-end-game">
          <div class="spider"></div>
          <div class="benia">
            <div class="message-box left message-300">
              <div class="top"></div>
              <div class="wrap left">
                  <h3 v-if="!errorList"> Przekroczyłeś budżet.<br /> Spróbuj jeszcze raz.</h3>
                  <h3 v-else> Nie skompletowałeś listy zakupów.<br /> Spróbuj jeszcze raz.</h3>
              </div>
              <div class="bottom"></div>
            </div>
          </div>
          <div class="action-bar">
            <button class="btn btn-green-light" @click="resetGame(3)"><span>Spróbuj jeszcze raz</span></button>
          </div>
        </div>
      </div>
      <div ref="wallet" class="wallet" v-if="cart & !paymentMethod">
        <div class="wrap">
          <h3 class="headline">Portfel</h3>
          <ul class="wallet-list">
            <li class="wallet-list_item"><h3>Budżet</h3><span>{{budget}}zł</span></li>
            <li class="wallet-list_item"><h3>Wydatki</h3><span>{{price}}zł</span></li>
            <li class="wallet-list_item"><h3>Reszta</h3><span>{{savings}}zł</span></li>
          </ul>
        </div>
      </div>
      <div class="col">
        <div class="intro-layer" v-if="introLayer">
          <div class="ducks">
            <div class="message-box left message-200">
              <div class="top"></div>
              <div class="wrap right">
                <h3>Kupuj tak, żeby została Ci reszta</h3>
              </div>
              <div class="bottom"></div>
            </div>
          </div>
          <div class="benia">
            <div class="message-box left message-300">
              <div class="top"></div>
              <div class="wrap left">
                <h3>Dostajesz <span>20zł</span> na zakupy. Kupuj produkty, przeciągając je do koszyka</h3>
              </div>
              <div class="bottom"></div>
            </div>
          </div>
          <button class="btn btn-green-light" id="startGame_3" @click="goShop()"><span>ROZPOCZNIJ</span></button>
        </div>
        <div class="col-claim shop" v-if="cart & !introLayer && !paymentMethod">
          <div class="benia">
            <div class="message-box left message-200">
              <div class="top"></div>
              <div class="wrap left">
                <h3>Lista Zakupów</h3>
                <ul class="shop-list">
                  <li class="shop-list_item"  v-for="(prod, sku) in this.productList.slice(0,shopGame.limit)" :key="sku" :id="prod.sku">{{ prod.name }}</li>
                </ul>
              </div>
              <div class="bottom"></div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <draggable
                  class="list-group product-list"
                  id="shopBoard"
                  :list="products"
                  :sort="false"
                  :group="{ name: 'products', pull: 'clone', put: false }"
                  @change="log"
              >
                <div class="product list-group-item" v-model="products"  v-for="element in products" :class="element.name.toLowerCase()" :key="element.index">
                  <img :src="require(`@/assets/images/shop/${element.img}`)">
                  <span v-if="setupGame.gameLevel == 'easy'">{{element.price}} zł</span>
                  <span v-else>{{element.hprice}} zł</span>
                </div>
              </draggable>
            </div>

          </div>

          <div class="pay">
            <button class="btn btn-blue"  @click="goBiling()"><span>PŁACĘ</span></button>
          </div>
        </div>
        <div class="bill" v-if="bill">
          <div class="duck-wrap"></div>
          <div class="wraperin">
            <div class="benia-wrap">
              <div class="benia">
                <div class="message-box left message-300">
                  <div class="top"></div>
                  <div class="wrap left" v-if="price <= shopGame.max && price != 0">
                    <h3><span>Brawo!</span></h3>
                    <p>Reszta z twoich zakupów to: <span class="green-txt">{{savings}} zł</span></p>
                    <p>Zgodnie z obietnicą otrzymujesz od mamy Kieszonkowe, czyli podwójną resztę a 2 razy  {{savings}} zł to : <span class="green-txt">{{bonus}} zł</span>! </p>
                    <h3><span class="green-txt">Misja Zaliczona</span>!</h3>
                  </div>
                  <div class="wrap left" v-else-if="price === budget && price != 0">
                    <h3><span>UDAŁO SIĘ! MISJA ZALICZONA! </span></h3>
                    <p>Twoje zakupy zmieściły się w budżecie.
                      Ale następnym razem rób zakupy tak, aby została Ci reszta!</p>
                  </div>
                  <div class="wrap left" v-else>
                    <h3><span>Udało się!</span></h3>
                    <p>Mogłeś zaoszczędzić więcej!</p>
                    <p>Reszta z twoich zakupów to: <span class="green-txt">{{savings}} zł</span></p>
                    <p>Zgodnie z obietnicą otrzymujesz od mamy Kieszonkowe, czyli podwójną resztę a 2 razy  {{savings}} zł to : <span class="green-txt">{{bonus}} zł</span>! </p>
                    <h3><span class="green-txt">Misja Zaliczona</span>!</h3>
                  </div>
                  <div class="bottom"></div>
                </div>
              </div>
            </div>
            <div class="wallet-wrap">
              <div class="wallet">
                <div class="claim">
                  <h3>Portfel</h3>
                  <ul class="baglist">
                    <li><h4>BUDŻET</h4> <span>{{budget}}zł</span></li>
                    <li><h4>WYDATKI</h4> <span>{{ price }}zł</span></li>
                    <li class="bills"><h4>RESZTA</h4> <span>{{savings}}zł</span></li>
                    <li class="bonus"><h4>KIESZONKOWE</h4> <span>{{bonus}}zł</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <draggable
            v-if="cart & !introLayer && !paymentMethod"
            ref="cart"
            class="dragArea list-group shoping-cart"
            :list="basket"
            group="products"
            @change="log"
        >
          <div class="cart-ico" >
            <i class="ico"></i>
            <span>Koszyk</span>
          </div>

        </draggable>



    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import MissionName from '@/components/missionName';
import Hero from "@/molecules/MoleculeHeroAvatar";
import GameIntro from '@/organism/OrganismGameIntro.vue';
import GameLvl from '@/organism/OrganismSelectLevel.vue';
import GameRules from '@/organism/OrganismGameRules';
import GameOrder from "@/organism/OrganismGameGetOrder";
import GameMap from "@/organism/OrganismGameMap";

import draggable from 'vuedraggable'
export default {
name: "index.vue",
  data(){
    return{
      gameIntro: false,
      steps: null,
      productlimit: null,
      budget: 20,
      savings: 0,
      bonus: 0,
      price: 0,
      max: 0,
      products:null,
      missionName: null,
      introLayer:true,
      cart: true,
      payment: false,
      paymentMethod: false,
      paymentSelected:false,
      selected:null,
      bill: false,
      showGameAccess: false,
      showGameMap:false,
      isActive: false,
      gameOver:false,
      productList:null,
      productListSKU:[],
      basket:[],
      allFounded:false,
      errorList:false,
      lastorder:false,
    }
  },
  methods:{
    ...mapMutations(['SET_ACTIVE_VIEW']),
    ...mapActions(['audioPlayer','stopAudio']),

    log: function(evt) {
      const sku = evt.added.element.sku
      const a = evt.added.element.price
      const b = evt.added.element.hprice
        if (this.productListSKU.includes(sku)){
          const itemlist = document.getElementById(sku);
          itemlist.classList.add('active');
        }
            if (this.setupGame.gameLevel == 'easy'){
              this.price = this.price + a
              this.savings = (this.budget - this.price);
              this.bonus = this.savings * 2;
            }else{
              this.price = this.price + b
              this.savings = (this.budget - this.price);
              this.bonus = this.savings * 2;
            }
        this.basket.push(sku);
        this.allFounded =  this.productListSKU.every( ai => this.basket.includes(ai) );
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },

    goShop(){
      this.introLayer = false;
      this.stopAudio();
      this.audioPlayer({
        'url': [
          '/shop/ogolne/lista_zakupow.mp3'
        ],
      })
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - ROZPOCZNIJ",
        label: "Zarządzam budżetem: Gameplay",  //  gameType
      })
    },
    selectMethod(payload){
      this.selected = payload;
      this.paymentSelected = true;
      this.isActive = !this.isActive;
    },
    goBiling() {
      if (this.savings > 0 && this.allFounded){
        this.audioPlayer({
          'url': [
            '/shop/reszta/01-reszta-z-twoich-zakupow.mp3',
            '/shop/money/'+this.savings +'zl.mp3',
            '/shop/reszta/02-reszta-z-twoich-zakupow.mp3',
            '/shop/money/'+this.savings+'zl.mp3',
            '/shop/reszta/03-reszta-z-twoich-zakupow.mp3',
            '/shop/money/'+this.bonus +'zl.mp3',
          ],
        })
      }

      if(this.savings === 0 & this.allFounded){
        this.audioPlayer({
          'url': [
            '/shop/end_game/udalo_sie.mp3',
          ],
        })
      }

      if (!this.allFounded ){
        this.gameOver = true;
        this.errorList = true;
        this.audioPlayer({
          'url': [
            '/shop/end_game/nie-skompletowales.mp3',
          ],
        })
      }else{
        this.paymentMethod = false;
        this.cart = false;
        this.bill = true;
      }

      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - PŁACĘ",
        label: "Zarządzam budżetem: Gameplay",  //  gameType
      })

    },
    resetGame(payload){
      this.SET_ACTIVE_VIEW(payload);
      this.gameOver = false;
      this.price = 0
      this.savings = 0
      if (this.setupGame.gameType == 1){
        this.gamenameGTM = "Pieniądze od podszewki"
      }else if(this.setupGame.gameType == 2){
        this.gamenameGTM = "Misja bezpieczeństwo"
      }else if(this.setupGame.gameType == 3){
        this.gamenameGTM = "Zarządzam budżetem"
      }
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - SPROBÓJ JESZCZE RAZ",
        label: this.gamenameGTM+": Przegrana",  //  gameType
      })
    },
  },
  components:{
    MissionName,
    GameIntro,
    GameLvl,
    GameRules,
    Hero,
    GameOrder,
    GameMap,
    draggable
  },
  watch:{
    gameIntro(){
      setTimeout(function(scope) {
        let StartGame3 = new Howl({
          src: [require('@/assets/audio/shop/ogolne/masz_20_zl.mp3')]
        });
        StartGame3.play();
        StartGame3.on('end', function(){
          let duck = new Howl({
            src: [require('@/assets/audio/shop/ogolne/kaczka_kupuj.mp3')]
          });
          duck.play();
        });
        }, 1900, this);

      let i = 0;
      for (i = 0; i < this.shopGame.limit; i ++){
        this.productListSKU.push(this.productList[i].sku);
      }
    },

    price(){
        if (this.savings < 0){
          this.gameOver = true
            this.audioPlayer({
              'url': [
                '/shop/end_game/przekroczony_budzet.mp3',
              ],
            })
        }
    },
    bill(){
      setTimeout(function(scope) {
        scope.showGameAccess = true;
        scope.audioPlayer({
          'url': [
            '/famfary/famfary.mp3'
          ],
        }),
        scope.bill = false;
            // }, 1500, this);
      }, 14500, this);
    },
    showGameAccess(){
      setTimeout(function(scope) {
        scope.showGameAccess = false;
        scope.lastorder = true;
        scope.showGameMap = true;
      }, 4000, this);
    },
  },
  computed: {
    ...mapGetters(['setupGame','shopGame']),
  },
  mounted() {
    this.missionName = this.shopGame.missionName;
    this.products = this.shopGame.products;
    this.productList = this.shopGame.productList;
    this.steps = this.shopGame.step;
    // --- SKU ARRAY ----

  }
}
</script>
